export default (className, nodeName = 'p') => {
  const discontinuationEle = document.createElement(nodeName);
  discontinuationEle.classList.add(...(className.split(' ').map(selector => `${selector}-label`)), 'c-discontinuation');
  discontinuationEle.textContent = '中止';

  return discontinuationEle;
}
